var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    id: "Group"
  }, /*#__PURE__*/React.createElement("line", {
    stroke: "null",
    id: "Stroke-2",
    y2: 20.02603,
    x2: 4.52381,
    y1: 20.02603,
    x1: 17.33333
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "Stroke-7",
    d: "m5.86511,15.73598l0,-1.4489c0,-2.7085 2.26729,-4.9032 5.06403,-4.9032c2.7939,0 5.06119,2.1947 5.06119,4.9032l0,1.4489l-10.12522,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m8.72135,3.72989c0,-1.21833 0.98776,-2.20608 2.20751,-2.20608c1.2169,0 2.20608,0.98776 2.20608,2.20608c0,1.21833 -0.98918,2.20608 -2.20608,2.20608c-1.21975,0 -2.20751,-0.98776 -2.20751,-2.20608z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/User.747234bb.svg";
export { ForwardRef as ReactComponent };